module.exports = __webpack_public_path__ + "assets/3928472e6cea558d644790fd790aad51.mp3";